module.exports = __webpack_public_path__ + "img/product-icon-2.1479aa63.png";